import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {change_password, clear_change_password_status} from "../../actions/auth";
import SnackbarMessage from "../Custom/SnackbarMessage";
import Validator from "../../utilities/validator";
import Grid from "@mui/material/Grid";
import {Box, FormControl, Paper} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import {switchMode} from "../../actions/theming";

const styles = {
    password: {
        "margin-top": 10
    },
    centered: {
        "text-align": "center",
        "paddingTop": 24,
        "paddingBottom": 24
    },
    loginWrapper: {
        textAlign: "center",
        paddingTop: "25vh",
        minHeight: "100vh",
        marginBottom: "60px"
    },
    logo: {
        paddingTop: 15,
        paddingBottom: 15,
        fontWeight: "bold",
        color: "white"
    },
    loginButtons: {
        flexDirection: "row-reverse"
    },
    loginHint: {
        flex: "auto"
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
    backToLogin: {
        marginBottom: 10
    },
    root: {
        marginTop: 15,
        marginLeft: 15,
        marginRight: 15,
        minHeight: "calc(100vh - 75px)",
        position: "relative"
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "10px"
    }
};


class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();
        this.state = {
            old_password: "",
            password: "",
            password_repeat: "",
            old_passwordTouched: false,
            passwordTouched: false,
            password_repeatTouched: false
        };
    }

    onSubmit = e => {
        e.preventDefault();
        this.recaptchaRef.current.execute().then(res => {
            const recaptchaToken = res;
            const {old_password, password, password_repeat} = this.state;
            if (!(old_password.length === 0 || password.length === 0 || password_repeat.length === 0 || password !== password_repeat) && Validator.isPasswordValid(old_password) && Validator.isPasswordValid(password)) {
                this.props.change_password(old_password, password, password_repeat, recaptchaToken);
            } else {
                this.setState({
                    ...this.state,
                    old_passwordTouched: true,
                    passwordTouched: true,
                    password_repeatTouched: true
                });
            }
        });
    };

    onChange = e => this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    render() {
        const {classes} = this.props;
        const {
            old_password,
            password,
            password_repeat,
            old_passwordTouched,
            passwordTouched,
            password_repeatTouched
        } = this.state;

        let errors = false;
        if (this.props.auth.change_password !== null) {
            if (this.props.auth.change_password.status === "error") {
                if (this.props.auth.change_password.errors) {
                    let errors_array = [];
                    Object.keys(this.props.auth.change_password.errors).map((field) => {
                        errors_array = [...errors_array, ...this.props.auth.change_password.errors[field]];
                    });
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_change_password_status} type="error"
                                             message={errors_array.join(", ")} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                } else {
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_change_password_status} type="error"
                                             message={this.props.auth.change_password.message} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                }
            } else if (this.props.auth.change_password.status === "success") {
                errors = (
                    <>
                        <SnackbarMessage onClose={this.props.clear_change_password_status} type="success"
                                         message={this.props.auth.change_password.message} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 15}}/>
                    </>
                )
            }
        }
        return (
            <Box
                className={classes.root}>
                <Grid container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                >
                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        size="invisible"
                        sitekey="6LcpS7kaAAAAACvn4UE6Mui2XRYfVyOSZROzvF9I"
                        // onChange={onChange}
                    />
                    <Grid item xs={12} md={6}>
                        <Paper style={{
                            padding: 20,
                            marginTop: 50,
                            background: this.props.theming.darkMode ? "black" : "white"
                        }}>
                            <Typography variant={"h5"}>Change password</Typography>
                            {errors}
                            <form onSubmit={this.onSubmit.bind(this)}>
                                <Grid container
                                      alignItems="flex-end">
                                    <Grid item xs={12} md={12}>
                                        <TextField fullWidth className={classes.password} label="Old password"
                                                   type="password"
                                                   variant="standard"
                                                   name="old_password" onChange={this.onChange} value={old_password}
                                                   error={old_passwordTouched && !Validator.isPasswordValid(old_password)}
                                                   helperText={old_passwordTouched && !Validator.isPasswordValid(old_password) ? "Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number" : ""}
                                        />
                                        <TextField fullWidth className={classes.password} label="New password"
                                                   type="password"
                                                   variant="standard"
                                                   name="password" onChange={this.onChange} value={password}
                                                   error={passwordTouched && !Validator.isPasswordValid(password)}
                                                   helperText={passwordTouched && !Validator.isPasswordValid(password) ? "Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number" : ""}
                                        />

                                        <TextField fullWidth className={classes.password} label="New password repeat"
                                                   type="password"
                                                   variant="standard"
                                                   name="password_repeat" onChange={this.onChange}
                                                   value={password_repeat}
                                                   error={password_repeatTouched && password_repeat !== password}
                                                   helperText={password_repeatTouched && password_repeat !== password ? "Please confirm your password" : ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} style={{paddingTop: 15}}>
                                        <FormControl>
                                            <Button variant="contained"
                                                    onClick={this.onSubmit.bind(this)}
                                                    disabled={!(!(old_password.length === 0 || password.length === 0 || password_repeat.length === 0 || password !== password_repeat) && Validator.isPasswordValid(old_password) && Validator.isPasswordValid(password))}
                                                    color="primary"
                                                    type="submit"
                                            >Save</Button>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    theming: state.theming
});

export default withStyles(styles)(connect(
    mapStateToProps,
    {change_password, clear_change_password_status, switchMode}
)(ChangePassword));
